import { PayloadAction } from '@reduxjs/toolkit';

export const agreementTemplateState = {
    formData: {
        createAs: 'url',
        templateName: '',
        url: '',
        originalUrl: '', // Add: Store original URL from backend
        agreementType: '',
        agreementSubType: '',
        validFrom: '',
        validTo: '',
        market: '',
        country: '',
        attachedFiles: {},
        originalAttachedFiles: [], // Add: Store original files from backend
        agreementIdentification: "",
        customerType: '',
        selectedAccount: null,
        companyAddress: '',
        primaryEmail: '',
        primaryName: '',
        primaryDesignation: '',
        agreementExpiry: '',
        addSecondary: false,
        secondaryEmail: '',
        secondaryName: '',
        saveMode: "",
        secondaryDesignation: '',
        nokiaSignatory1Email: '',
        nokiaSignatory1Name: '',
        nokiaSignatory1Designation: '',
        addNokiaSignatory2: false,
        nokiaSignatory2Email: '',
        nokiaSignatory2Name: '',
        nokiaSignatory2Designation: '',
        signingOrder: 'external',
        signatory1Acceptance: null,
        signatory1Authorization: null,
        signatory2Acceptance: null,
        signatory2Authorization: null,
        signatory3Acceptance: null,
        signatory3Authorization: null,
        signatory4Acceptance: null,
        signatory4Authorization: null,
        editedHtmlContent: '',
        editedDocxFile: null,
        originalHtmlContent: '',
        esignStatus: 'draft',
        esignAdditionalStatus: ""
    },
    mode: 'create', // 'create', 'edit', 'view', 'review'
    isProcessing: false,
    isLoaded: false,
    selectedAgreementDetails: null,
    esignAgreementId: '',
    esignAgreementStatus: null,
    previewUrl: '', // For URL preview
    previewFile: null, // For uploaded file preview
}

export const agreementTemplateReducers = {
    setAgreementTemplateFormData(state: any, action: PayloadAction<any>) {
        state.data.agreementTemplate.formData = action.payload;
    },
    setAgreementTemplateFormDataByKey(state: any, action: PayloadAction<{ key: string; value: string | object | boolean | any }>) {
        const { key, value } = action.payload;
        state.data.agreementTemplate.formData[key] = value;
    },
    setAgreementTemplateProcessingState(state: any, action: PayloadAction<boolean>) {
        state.data.agreementTemplate.isProcessing = action.payload;
    },
    setAgreementTemplateLoadedState(state: any, action: PayloadAction<boolean>) {
        state.data.agreementTemplate.isLoaded = action.payload;
    },
    setAgreementTemplateSelectedAgreementDetails(state: any, action: PayloadAction<any>) {
        state.data.agreementTemplate.selectedAgreementDetails = action.payload;
    },
    setAgreementTemplateEsignAgreementId(state: any, action: PayloadAction<string>) {
        state.data.agreementTemplate.esignAgreementId = action.payload;
    },
    setAgreementTemplateEsignAgreementStatus(state: any, action: PayloadAction<any>) {
        state.data.agreementTemplate.esignAgreementStatus = action.payload;
    },
    setAgreementTemplatePreviewUrl(state: any, action: PayloadAction<string>) {
        state.data.agreementTemplate.previewUrl = action.payload;
        state.data.agreementTemplate.previewFile = null; // Clear file when URL is set
    },
    setAgreementTemplatePreviewFile(state: any, action: PayloadAction<any>) {
        state.data.agreementTemplate.previewFile = action.payload;
        state.data.agreementTemplate.previewUrl = ''; // Clear URL when file is set
    },
    setAgreementTemplateAttachedFiles(state: any, action: PayloadAction<any>) {
        // Set single file (first file from uploaded files)
        const file =  action.payload;
        state.data.agreementTemplate.formData.attachedFile = file;
        
        // Set preview file
        if (file) {
            state.data.agreementTemplate.previewFile = file;
        }
    },
    setAgreementTemplateDeletedFiles(state: any) {
        // Clear single file
        state.data.agreementTemplate.formData.attachedFile = null;
        state.data.agreementTemplate.previewFile = null;
    },
    resetAgreementUserDetails(state:any){
        state.data.agreementTemplate.formData.primaryEmail = '';
        state.data.agreementTemplate.formData.primaryName = '';
        state.data.agreementTemplate.formData.primaryDesignation = '';
        state.data.agreementTemplate.formData.secondaryEmail = '';
        state.data.agreementTemplate.formData.secondaryName = '';
        state.data.agreementTemplate.formData.secondaryDesignation = '';
        state.data.agreementTemplate.formData.nokiaSignatory1Email = '';
        state.data.agreementTemplate.formData.nokiaSignatory1Name = '';
        state.data.agreementTemplate.formData.nokiaSignatory1Designation = '';
        state.data.agreementTemplate.formData.nokiaSignatory2Email = '';
        state.data.agreementTemplate.formData.nokiaSignatory2Name = '';
        state.data.agreementTemplate.formData.nokiaSignatory2Designation = '';
    },
    clearAgreementTemplatePreview(state: any) {
        state.data.agreementTemplate.previewUrl = '';
        state.data.agreementTemplate.previewFile = null;
    },
    setAgreementTemplateMode(state: any, action: PayloadAction<'create' | 'edit' | 'view' | 'review'>) {
        state.data.agreementTemplate.mode = action.payload;
    }
}